







import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import ReactPaginate from 'react-paginate';

import {
    Card,
    Row,
    Col,
    CardTitle,
    CardBody,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    FormText,
    Table
} from "reactstrap";
import { useSelector } from 'react-redux';
import { encryptUserId } from '../../utils/shortEncrypt';



const VenderMaster = () => {
    const navigate = useNavigate();
    const [venderMaster, setVenderMasterTable] = useState([]);
    const [totalPage, setTotalPage] = useState();
    const { user } = useSelector((state) => state.authState);

    const onHandleSearchKeyItem = (e) => {
        const value = e.target.value;
        getCompanyMasterData(1, 10, value)
    }

    const onHandleAddCompanyMaster = () => {
        navigate("/addvendor")
    }

    const onHandleEditCompanyMaster = (id) => {
        let findArrayData = venderMaster.find(e => e.id === id)
        navigate('/addvendor', { state: { companyId: findArrayData?.id } });
    }

    const getCompanyMasterData = async (page = 1, limit = 10, search = "") => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`api/VenderMaster/all?pageNo=${page}&limit=${100000}&searchKey=${search}`, config)
            if (response.response && response.response.data.errors) {
                toast.error(response.response?.data?.errors);
            }

            if (response.status === true) {
                // console.log(response.CompanyMasterMasterData)
                setVenderMasterTable(response.venderMasterData)
                // toast.success(response.message);
            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
    };

    useEffect(() => {
        getCompanyMasterData();
    }, [!venderMaster]);

    const handlePageClick = (data) => {
        getCompanyMasterData(data.selected + 1)
    };

    
    const launchVendorWebsite = (vender_slug, venderId, uniqueCode) => {
        let encrypt = encryptUserId(Number(venderId))
        const url = `/${vender_slug}/home`;
        window.open(url, '_blank', 'noopener,noreferrer');
    };


    const onHandleDeleteCompanyMaster = async (id) => {

        const isDeleteConfirmed = window.confirm('Are you sure you want to delete this item?');
        if (isDeleteConfirmed) {
            try {
                let config = {
                    headers: {
                        'Content-Type': 'application/json', // Important for file upload//s
                        'accept': 'application/json'
                    }
                };

                const response = await apiService.delete(`api/VenderMaster/delete?companyId=${id}`, config)
                if (response.response && response.response.data.errors) {
                    toast.error(response.response?.data?.errors);
                }

                if (response.status === true) {
                    toast.success(response.message);
                    getCompanyMasterData()
                }
                else {
                    toast.success(response.message);
                }
            } catch (error) {
                console.log(error)
                toast.error(`SomeThing went wrong!!`);
            }
        } else {
            console.log('Deletion canceled.');
        }
    };

    return (
        <>
            <Col lg="12">
                <Card className='bg-white pd-10 card-box mb-30'>
                    <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between sticky-top">
                        {/* <div className="d-flex align-items-center">
                            <i className="bi bi-card-text mr-2"></i>
                            Website/Application User Master
                        </div>

                        <Row className="align-items-center" style={{ marginRight: '10px', width: '300px' }}>
                            <Input  id="search" name="search" placeholder="Search..." type="text" onChange={(e) => { onHandleSearchKeyItem(e) }} />
                        </Row>

                        {user.user_profile === "superadmin" && <Button color="primary" size="bg" onClick={onHandleAddCompanyMaster}>Add</Button>
                        } */}



                        <Col>
                            <Row className="align-items-center  g-0 mb-2">
                                <Col xs={12} className="d-flex justify-content-between align-items-center">
                                    {/* Title aligned left */}
                                    <div className="d-flex align-items-center">
                                        <i className="bi bi-card-text mr-2"></i>
                                        Vender Master
                                    </div>
                                    <div className="d-flex justify-content-end mb-2">
                                        {user.user_profile === "superadmin" && <Button color="success" onClick={onHandleAddCompanyMaster} className="d-flex align-items-center">
                                            <i className="bi bi-plus-circle mr-2"></i>
                                            New
                                        </Button>}
                                    </div>

                                </Col>
                            </Row>

                            <Row style={{ display: "flex", justifyContent: "start" }}>
                                <Col xl={12} md={6} className="d-flex justify-content-center justify-content-md-end align-items-center gap-2">
                                    <Input
                                        
                                        id="search"
                                        name="search"
                                        placeholder="Search..."
                                        type="text"
                                        // style={{ minWidth: '250px' }}
                                        onChange={(e) => onHandleSearchKeyItem(e)}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </CardTitle>

                    <CardBody className="">
                        <Table striped>
                            <thead>
                                <tr>
                                     <th>S. no.</th>
                                    <th> Company Name.</th>
                                    <th> Mobile No..</th>
                                    <th>Website </th>
                                    {/* {(user.user_profile === "admin" || user.user_profile === "superadmin") &&
                                        <>
                                            <th>Edit</th>
                                        </>
                                    } */}
                                </tr>
                            </thead>
                            <tbody>
                                {venderMaster.map((item, index) => (

                                    <tr key={index}>
                                        {/* <th scope="row">{index + 1}</th> */}

                                        <th scope='row'>
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "start", flexDirection: "column" }}>
                                                <span className='ms-2'>{index + 1}</span>

                                                {(user.user_profile === "admin" || user.user_profile === "superadmin") && <Button
                                                    color="warning"
                                                    className="me-0 ms-2"
                                                    size="sm"
                                                    onClick={() => onHandleEditCompanyMaster(item.id)}
                                                >
                                                    <p style={{ fontSize: 12, padding: 0, margin: 0, fontWeight: "bold" }}><i className="bi bi-pencil mr-1"></i>Edit</p>
                                                </Button>}

                                            </div>
                                        </th>
                                        {/* <td>{item.id}</td> */}

                                        {/* <td>{<img style={{ width: 60, height: 60, borderRadius: 100 }} src={API_URL + item.room_image}></img>}</td> */}
                                        <td>{item.vender_name}</td>
                                        <td>{item.vender_mobile}</td>
                                        {/* <td><Button
                                            color="warning"
                                            className="me-0 ms-2"
                                            size="sm"
                                            onClick={() => onHandleEditCompanyMaster(item.id)}
                                        >
                                            <p style={{ fontSize: 12, padding: 0, margin: 0, fontWeight: "bold" }}><i className="bi bi-pencil mr-1"></i>Edit</p>
                                        </Button></td> */}
                                        <td>
                                            {item.vender_website_lunch === "yes" ?
                                                <>
                                                    <button
                                                        className="btn btn-primary btn-sm"
                                                        onClick={() => launchVendorWebsite(item.vender_slug, item.id, item.unique_code)}
                                                    >
                                                        Launch Website
                                                    </button>
                                                </>
                                                :
                                                <><span>No Website</span>
                                                </>
                                            }
                                        </td>

                                        {/* {(user.user_profile === "admin" || user.user_profile === "superadmin") &&
                                            <>
                                                <td>
                                                    <Button color="warning" size="bg" onClick={() => onHandleEditCompanyMaster(item.id)}>
                                                        <i className="bi bi-pencil text-primary" style={{cursor:"pointer"}}></i>
                                                    </Button>
                                                </td>
                                                <td>
                                                    <Button color="danger" size="bg" onClick={() => onHandleDeleteCompanyMaster(item.id)}>
                                                        <i className="bi bi-trash"></i>
                                                    </Button>
                                                </td>
                                            </>
                                        } */}
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </CardBody>

                    <CardBody>
                        {/* <ReactPaginate
                            previousLabel={'Previous'}
                            nextLabel={'Next'}
                            breakLabel={'...'}
                            breakClassName={'break-me'}
                            pageCount={totalPage}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={handlePageClick}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        /> */}
                        <ReactPaginate
                            previousLabel={'Previous'}
                            nextLabel={'Next'}
                            breakLabel={'...'}
                            pageCount={totalPage} // still 4000
                            marginPagesDisplayed={1} // 1 page at start & end
                            pageRangeDisplayed={2}  // visible range around selected page
                            onPageChange={handlePageClick}
                            containerClassName={'pagination'}
                            activeClassName={'active'}

                            pageClassName={'page-item'}
                            pageLinkClassName={'page-link'}
                            previousClassName={'page-item'}
                            nextClassName={'page-item'}
                            previousLinkClassName={'page-link'}
                            nextLinkClassName={'page-link'}
                            breakClassName={'page-item'}
                            breakLinkClassName={'page-link'}
                        />
                    </CardBody>
                </Card>
            </Col>
        </>
    )
}

export default VenderMaster

